<div class="patient-data" *ngIf="patient">
  <div class="container">
    <ng-container *ngFor="let item of config">
      <div
        class="header-block"
        [ngStyle]="{ 'grid-column': 'span ' + item.span }"
      >
        <span class="title">{{
          "PATIENT_DATA." + item.key | uppercase | translate
        }}</span>
        <span class="content">{{ patient[item.key] }}</span>
      </div>
    </ng-container>
  </div>
</div>
